// extracted by mini-css-extract-plugin
export default {"price-input":"_3AYPi","priceInput":"_3AYPi","premium-selected":"_2hC_Q","premiumSelected":"_2hC_Q","full-width":"tC0F_","fullWidth":"tC0F_"};